<template>
    <v-container dense fluid class='pa-0'>
        <v-card
            color = 'grey lighten-4'
            flat
            height = '64px'
            tile
        >
            <v-app-bar 
                color = 'primary'
                width='100%'
                fixed
            >
                <v-app-bar-nav-icon
                    @click="drawer = !drawer"
                >
                </v-app-bar-nav-icon>
                <v-toolbar-title>Carbon Insights Platform</v-toolbar-title>
                <v-chip
                    class="mx-4"
                    outlined
                    color='secondary'
                    small
                >
                    <span><i>{{ version }}</i></span>
                </v-chip>

                <v-spacer></v-spacer>

            </v-app-bar>
            <v-navigation-drawer
                v-model="drawer"
                app
                temporary
                class = 'grey lighten-4'
            >
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title><i>creating with conscience</i></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list dense>

                    <v-list-item
                        v-for="item in items"
                        :key="item.title"
                        link
                        :to="item.route"
                    >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>

        </v-card>       
    </v-container>
</template>

<script>

export default {
    name: 'Toolbar',
    data () {
        return {
            version: 'v 0.2.5',

            drawer: null,
            items: [
                { title: 'Home', icon: 'mdi-home', route: '/' },
                // { title: 'About', icon: 'mdi-information', route: '/about' },
                { title: 'Buildings Typology Library', icon: 'mdi-book', route: '/typ-library-buildings' },
                { title: 'Infrastructure Typology Library', icon: 'mdi-book-information-variant', route: '/typ-library-infrastructure' },
                { title: 'Pre-Design Calculator', icon: 'mdi-calculator', route: '/calculator' },               
                { title: 'Insights from Projects', icon: 'mdi-chart-donut', route: '/insights' },
                // { title: 'Project Case Studies', icon: 'mdi-bookmark-multiple-outline', route: '/case-studies' },
                // { title: 'Guidance', icon: 'mdi-sign-direction', route: '/guidance' },
                { title: 'Contributors', icon: 'mdi-account-group', route: '/contributors' },
                
            ]
        }
    }
}
</script>